export default "__VITE_ASSET__LO0K7mA3__"